import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";

import App from "./App";
import store from "./redux/store"


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <Provider store={store}>
        <React.StrictMode>
            <BrowserRouter>
                <Suspense fallback={<></>}>
                    <App />
                </Suspense>
            </BrowserRouter>
        </React.StrictMode>
    </Provider>
);

reportWebVitals();
